<template lang="pug">
  .component-booking-mode
    select(@change="$emit('input', $event.target.value)", :disabled="disabled", v-if="$is('select')" )
      option(v-if="isFilter", :value="null", selected="") All booking types
      option(v-for="(bookingMode, key) in bookingModes", :selected="value === key", :value="key") {{bookingMode}}
    fieldset(v-else-if="$is('checkbox')" )
      h3 Booking Modes
      template(v-for="(bookingMode, key) in bookingModes")
        label {{bookingMode}}
          input(type="checkbox", @change="$emit('input', selected)", v-model="selected", :value="key", :checked="value === key")
</template>

<script>
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

export default {
  name: 'BookingModeSelect',
  data() {

    return {
      bookingModes: {},
      selected: this.value
    }
  },
  props: {
    value: {},
    isFilter: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'select'
    }
  },
  created() {
    KeplerBackofficeSdk.reservations.list().modes((data) => {
      Object.keys(data).map((key) => {
        data[key] = data[key].replace('App\\Models\\ConcreteReservations\\', '').replace('Reservation', '');
      });

      this.bookingModes = data;
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// BookingModeSelect.vue?7b61055c